function createImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("Failed to load image for cropping."));
    image.src = url;
  });
}

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(new Error("Unable to read selected image file."));
    reader.readAsDataURL(file);
  });
}

function extensionFromMimeType(mimeType) {
  switch (mimeType) {
    case "image/png":
      return "png";
    case "image/webp":
      return "webp";
    case "image/gif":
      return "gif";
    default:
      return "jpg";
  }
}

function sanitizeBaseName(fileName) {
  const withoutExtension = String(fileName || "ad-image")
    .replace(/\.[^/.]+$/, "")
    .trim()
    .replace(/[^a-zA-Z0-9_-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

  return withoutExtension || "ad-image";
}

export async function cropImageToFile({
  imageSrc,
  cropPixels,
  outputWidth,
  outputHeight,
  fileName,
  mimeType,
}) {
  if (!imageSrc || !cropPixels) {
    throw new Error("Missing crop data.");
  }

  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = outputWidth;
  canvas.height = outputHeight;

  const context = canvas.getContext("2d");
  if (!context) {
    throw new Error("Canvas not available.");
  }

  context.drawImage(
    image,
    cropPixels.x,
    cropPixels.y,
    cropPixels.width,
    cropPixels.height,
    0,
    0,
    outputWidth,
    outputHeight
  );

  const mimeCandidate = String(mimeType || "image/jpeg");
  const safeMimeType = mimeCandidate.startsWith("image/") ? mimeCandidate : "image/jpeg";
  const ext = extensionFromMimeType(safeMimeType);
  const baseName = sanitizeBaseName(fileName);
  const finalName = `${baseName}-cropped.${ext}`;

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => {
        if (!b) {
          reject(new Error("Failed to generate cropped image."));
          return;
        }
        resolve(b);
      },
      safeMimeType,
      0.92
    );
  });

  return new File([blob], finalName, {
    type: safeMimeType,
    lastModified: Date.now(),
  });
}